export default "__VITE_ASSET__01a9b456__"